import * as portfolioData from '../../portfolioData';
import { PortfolioImage } from './image-modal'

export const TheWeightOfAnObject = () => {
  return (
    PortfolioImage(portfolioData.theWeightOfAnObjectImage)
  )
}

export const Apothecia = () => {
  return (
    PortfolioImage(portfolioData.apotheciaImage)
  )
}

export const Burdensome = () => {
  return (
    PortfolioImage(portfolioData.burdensomeImage)
  )
}

export const ChainReaction = () => {
  return (
    PortfolioImage(portfolioData.chainReactionImage)
  )
}

export const Decorative = () => {
  return (
    PortfolioImage(portfolioData.decorativeImage)
  )
}

export const DefenseMechanism = () => {
  return (
    PortfolioImage(portfolioData.defenseMechanismImage)
  )
}

export const EpithelialNeoplasms = () => {
  return (
    PortfolioImage(portfolioData.epithelialNeoplasmsImage)
  )
}

export const DreamBig = () => {
  return (
    PortfolioImage(portfolioData.dreamBigImage)
  )
}

export const FragileMyths = () => {
  return (
    PortfolioImage(portfolioData.fragileMythsImage)
  )
}

export const Excessive = () => {
  return (
    PortfolioImage(portfolioData.excessiveImage)
  )
}

export const Expectations = () => {
  return (
    PortfolioImage(portfolioData.expectationsImage)
  )
}

export const BodySculptures = () => {
  return (
    PortfolioImage(portfolioData.bodySculpturesImage)
  )
}

export const Osteoderm = () => {
  return (
    PortfolioImage(portfolioData.osteodermImage)
  )
}

export const PhalangealThelodonts = () => {
  return (
    PortfolioImage(portfolioData.phalangealThelodontsImage)
  )
}

export const Profligacy = () => {
  return (
    PortfolioImage(portfolioData.profligacyImage)
  )
}

export const ProjectionIdentificationEmpathy = () => {
  return (
    PortfolioImage(portfolioData.projectionIdentificationEmpathyImage)
  )
}

export const SelfFulfillingProphecy = () => {
  return (
    PortfolioImage(portfolioData.selfFulfillingProphecyImage)
  )
}

export const WildSeeds = () => {
  return (
    PortfolioImage(portfolioData.wildSeedsImage)
  )
}
